import React from 'react'
import { Title } from './style'

export default ({children, ...props}) => <Title {...props}>{children}</Title>